var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dataForm.id ? "编辑配置" : "新增配置",
            visible: _vm.dialogVisible,
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            width: "900px",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingFrom,
                      expression: "loadingFrom",
                    },
                  ],
                  ref: "dataForm",
                  attrs: {
                    model: _vm.dataForm,
                    "label-width": "140px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品编号:", prop: "productCode" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入产品编号(唯一)",
                          maxlength: "64",
                          disabled: !!_vm.dataForm.id,
                        },
                        model: {
                          value: _vm.dataForm.productCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dataForm,
                              "productCode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dataForm.productCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "页面名称:", prop: "pageName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入页面名称",
                          maxlength: "128",
                        },
                        model: {
                          value: _vm.dataForm.pageName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dataForm,
                              "pageName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dataForm.pageName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "页面主图:" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: { click: _vm.modalPicTap },
                      },
                      [
                        _vm.dataForm.headerImage
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", {
                                attrs: { src: _vm.dataForm.headerImage },
                              }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("建议尺寸(750*400)"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("el-form-item", { attrs: { label: "背景颜色:" } }, [
                    _c(
                      "div",
                      { staticClass: "color-picker-box" },
                      [
                        _c("el-color-picker", {
                          on: { change: _vm.handleColorChange },
                          model: {
                            value: _vm.dataForm.backgroundColor,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "backgroundColor", $$v)
                            },
                            expression: "dataForm.backgroundColor",
                          },
                        }),
                        _c("el-input", {
                          staticStyle: {
                            width: "200px",
                            "margin-left": "10px",
                          },
                          attrs: {
                            placeholder: "请选择背景颜色",
                            clearable: "",
                          },
                          model: {
                            value: _vm.dataForm.backgroundColor,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "backgroundColor", $$v)
                            },
                            expression: "dataForm.backgroundColor",
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { size: "small" },
                            on: { click: _vm.resetBackgroundColor },
                          },
                          [_vm._v(" 重置 ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品说明:" } },
                    [
                      _c("Tinymce", {
                        attrs: { height: 300 },
                        model: {
                          value: _vm.dataForm.productDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "productDesc", $$v)
                          },
                          expression: "dataForm.productDesc",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "提交按钮文案:",
                        prop: "submitButtonText",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入提交按钮文案",
                          maxlength: "32",
                        },
                        model: {
                          value: _vm.dataForm.submitButtonText,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dataForm,
                              "submitButtonText",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dataForm.submitButtonText",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序:" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 9999 },
                        model: {
                          value: _vm.dataForm.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "sort", $$v)
                          },
                          expression: "dataForm.sort",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("隐私协议配置"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否启用隐私协议:" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "启用",
                          "inactive-text": "禁用",
                        },
                        model: {
                          value: _vm.dataForm.enablePrivacy,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "enablePrivacy", $$v)
                          },
                          expression: "dataForm.enablePrivacy",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.dataForm.enablePrivacy
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "隐私协议内容:" } },
                        [
                          _c("Tinymce", {
                            attrs: { height: 300 },
                            model: {
                              value: _vm.dataForm.privacyContent,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "privacyContent", $$v)
                              },
                              expression: "dataForm.privacyContent",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("二次确认配置"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否启用二次确认:" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "启用",
                          "inactive-text": "禁用",
                        },
                        model: {
                          value: _vm.dataForm.enableSecondConfirm,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "enableSecondConfirm", $$v)
                          },
                          expression: "dataForm.enableSecondConfirm",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.dataForm.enableSecondConfirm
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "二次确认说明:" } },
                        [
                          _c("Tinymce", {
                            attrs: { height: 300 },
                            model: {
                              value: _vm.dataForm.secondConfirmContent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dataForm,
                                  "secondConfirmContent",
                                  $$v
                                )
                              },
                              expression: "dataForm.secondConfirmContent",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("成功弹窗配置"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否启用成功弹窗:" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "启用",
                          "inactive-text": "禁用",
                        },
                        model: {
                          value: _vm.dataForm.enableSuccessPopup,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "enableSuccessPopup", $$v)
                          },
                          expression: "dataForm.enableSuccessPopup",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.dataForm.enableSuccessPopup
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "成功提示内容:" } },
                        [
                          _c("Tinymce", {
                            attrs: { height: 300 },
                            model: {
                              value: _vm.dataForm.successPopupContent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dataForm,
                                  "successPopupContent",
                                  $$v
                                )
                              },
                              expression: "dataForm.successPopupContent",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("其他配置"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态:" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "启用",
                          "inactive-text": "禁用",
                        },
                        model: {
                          value: _vm.dataForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "status", $$v)
                          },
                          expression: "dataForm.status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [
                        "platform:product:page:config:save",
                        "platform:product:page:config:update",
                      ],
                      expression:
                        "['platform:product:page:config:save', 'platform:product:page:config:update']",
                    },
                  ],
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit("dataForm")
                    },
                  },
                },
                [_vm._v(" 保存 ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }